const BREAKPOINTS = {
  SM: 768, // Small devices
  MD: 1024, // Medium devices
  LG: 1400 // Large devices
};

export default BREAKPOINTS;